export class HandledApiError extends Error {
    // Private, so no serializer (Sentry's included) walks into the backend's payload.
    #statusText;
    #json;

    constructor({status, statusText, type, json, silent, err}) {
        super(`Request failed with status ${status}`);
        this.name = 'HandledApiError';
        this.status = status;
        this.#statusText = statusText;
        this.type = type;
        this.#json = json;
        this.silent = silent;
        this.err = err;
        this.cause = err;
    }

    get statusText() {
        return this.#statusText;
    }

    get json() {
        return this.#json;
    }
}
